'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Carousel = require('./components/Carousel');
var _Carousel2 = _interopRequireDefault(_Carousel);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = _Carousel2.default;